import { useState, useEffect } from 'react';
import { useDebouncedCallback  } from 'use-debounce';
import { useNavigate } from 'react-router-dom';
import Carousel from '../../../assets/carousel';
import useAuth from '../../../hooks/useAuth';
import { getPublicImgUrl } from '../../../utils/common';
import api from '../../../api/axios';
import { useLoading } from '../../../components/LoadingProvider';
import { showSuccess, showError } from '../../../utils/toast';
import moment from 'moment';

function DoctorDashboard() {
    const navigate = useNavigate();
    const { setIsLoading } = useLoading();
    const { user, userRole } = useAuth({ redirectPath: '/login', allowedRoles: ['doctor'] });
    const debounced = useDebouncedCallback((value) => {
        console.log(value);
    }, 1000);
    const [appointments, setAppointments] = useState({
        upcoming: [],
        ongoing: [],
        previous: []
    });
    const [appointmentActiveTab, setAppointmentActiveTab] = useState('upcoming');
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);
    // const [value, setValue] = useState([thirtyDaysAgo, today]);

    useEffect(() => {
        document.title = 'Varosa - Doctor Dashboard';
        // Check authentication status
        if (!user) {
            navigate('/login');
            return;
        }
        fetchAppointments();
    }, [user, navigate]);

    useEffect(() => {
        // Initialize carousel
        const initCarousel = () => {
            const carouselElement = document.getElementById('headerCarousel');
            if (carouselElement) {
                const carousel = new Carousel(carouselElement);

                // Add button controls
                const prevBtn = document.getElementById('prevBtn');
                const nextBtn = document.getElementById('nextBtn');

                if (prevBtn && nextBtn) {
                    prevBtn.addEventListener('click', () => {
                        carousel.stopAutoPlay();
                        carousel.prevSlide();
                        carousel.startAutoPlay();
                    });

                    nextBtn.addEventListener('click', () => {
                        carousel.stopAutoPlay();
                        carousel.nextSlide();
                        carousel.startAutoPlay();
                    });
                }
            }
        };
        const initTestimonialCarousel = () => {
            const carouselElement = document.getElementById('testimonialCarousel');
            if (carouselElement) {
                const carousel = new Carousel(carouselElement);

                // Add button controls
                const prevBtn = document.getElementById('prevBtnT');
                const nextBtn = document.getElementById('nextBtnT');

                if (prevBtn && nextBtn) {
                    prevBtn.addEventListener('click', () => {
                        carousel.stopAutoPlay();
                        carousel.prevSlide();
                        carousel.startAutoPlay();
                    });

                    nextBtn.addEventListener('click', () => {
                        carousel.stopAutoPlay();
                        carousel.nextSlide();
                        carousel.startAutoPlay();
                    });
                }
            }
        };

        initCarousel();
        initTestimonialCarousel();
    }, []);

    const fetchAppointments = async () => {
        try {
            setIsLoading(true);
            const response = await api.get(`/${userRole}/appointments`, {
                params: {
                    start_date: moment().format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                },
            });
            if (response?.data?.result === 'success') {
                setAppointments({
                    upcoming: response?.data?.data?.upcoming_appointments || [],
                    ongoing: response?.data?.data?.ongoing_appointments || [],
                    previous: response?.data?.data?.completed_appointments || []
                });
                return;
            } else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError('Error fetching appointments:', error?.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="container-fluid py-3">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="bg-light rounded p-4">
                                <h2 className="mb-0">Welcome, {user?.name || 'User'}!</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid position-relative p-0">
                <div className="header-carousel" id="headerCarousel">
                    <div className="header-carousel-item">
                        <img src={getPublicImgUrl()+"/banner-1.png"} className="img-fluid w-100" alt="img" />
                        {/* <div className="carousel-caption">
                            <div className="carousel-caption-content p-3">
                                <a className="book-btn" href="#findDoctor">Book Appointment</a>
                            </div>
                        </div> */}
                    </div>
                    <div className="header-carousel-item">
                        <img src={getPublicImgUrl()+"/banner-2.png"} className="img-fluid w-100" alt="img" />
                        {/* <div className="carousel-caption">
                            <div className="carousel-caption-content p-3">
                                <a className="btn btn-primary rounded-pill text-white py-3 px-5" href="#findDoctor">Book Appointment</a>
                            </div>
                        </div> */}
                    </div>
                    <div className="header-carousel-item">
                        <img src={getPublicImgUrl()+"/banner-3.png"} className="img-fluid w-100" alt="img" />
                        {/* <div className="carousel-caption">
                            <div className="carousel-caption-content p-3">
                                <a className="btn btn-primary rounded-pill text-white py-3 px-5" href="#findDoctor">Book Appointment</a>
                            </div>
                        </div> */}
                    </div>
                    <div className="owl-nav">
                        <div className="owl-prev" id="prevBtn"><i className="bi bi-arrow-left"></i></div>
                        <div className="owl-next" id="nextBtn"><i className="bi bi-arrow-right"></i></div>
                    </div>
                </div>
            </div>
            <div className="container-fluid feature bg-light py-5" id="findDoctor">
                <div className="container">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.2s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Todays Appointments</h4>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-center">
                        <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
                            <ul className="nav nav-pills mb-3 justify-content-center" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button 
                                        className={`nav-link ${appointmentActiveTab === 'upcoming' ? 'active' : ''}`} 
                                        id="pills-upcoming-tab" data-toggle="pill" data-target="#pills-upcoming" 
                                        type="button" role="tab" aria-controls="pills-upcoming" aria-selected="true" 
                                        onClick={() => setAppointmentActiveTab('upcoming')}
                                    >Upcoming</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button 
                                        className={`nav-link ${appointmentActiveTab === 'ongoing' ? 'active' : ''}`} 
                                        id="pills-ongoing-tab" data-toggle="pill" data-target="#pills-ongoing" 
                                        type="button" role="tab" aria-controls="pills-ongoing" aria-selected="false" 
                                        onClick={() => setAppointmentActiveTab('ongoing')}
                                    >Ongoing</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button 
                                        className={`nav-link ${appointmentActiveTab === 'previous' ? 'active' : ''}`} 
                                        id="pills-previous-tab" data-toggle="pill" data-target="#pills-previous" 
                                        type="button" role="tab" aria-controls="pills-previous" aria-selected="false" 
                                        onClick={() => setAppointmentActiveTab('previous')}
                                    >Previous</button>
                                </li>
                            </ul>
                            <hr />
                            <div className="tab-content" id="pills-tabContent">
                                <div className={`tab-pane fade ${appointmentActiveTab === 'upcoming' ? 'show active' : ''}`} id="pills-upcoming" role="tabpanel" aria-labelledby="pills-upcoming-tab">
                                    <div className="row g-3">
                                        {appointments.upcoming.length === 0 && (<h4 className="mb-4 text-center">No Upcoming Appointments</h4>)}
                                        {appointments.upcoming.map((item, index, arr) => (
                                            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s" key={item.id}>
                                                <div className="team-item rounded">
                                                    <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                                        <img src={item.patient_profile_picture || (getPublicImgUrl()+'/profile_8747415.png')} className="img-fluid rounded-top w-100" style={{ maxHeight: '250px', objectFit: 'contain' }} alt="" />
                                                    </div>
                                                    <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                                        <h5 className="mb-2">{item.patient_name}</h5>
                                                        <div className="appointment-item-div mb-3"><span><b>Date:</b></span> <span>{item.appointment_date}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Time:</b></span> <span>{item.appointment_time}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Reason:</b></span> <span>{item.visit_reason}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Payment Status:</b></span> <span>{item.payment_status ?? 'N/A'}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Booking Status:</b></span> <span>{item.booking_status ?? 'N/A'}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Fees:</b></span> <span><b>&#8377;{item.total_amount}</b></span></div>
                                                        <hr />
                                                        <button type="button" onClick={() => navigate(`/dashboard/doctor/appointment/${item.id}`)} className="btn btn-primary">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${appointmentActiveTab === 'ongoing' ? 'show active' : ''}`} id="pills-ongoing" role="tabpanel" aria-labelledby="pills-ongoing-tab">
                                    <div className="row g-3 justify-content-center">
                                        {appointments.ongoing.length === 0 && (<h4 className="mb-4 text-center">No Ongoing Appointments</h4>)}
                                        {appointments.ongoing.map((item, index, arr) => (
                                            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s" key={item.id}>
                                                <div className="team-item rounded">
                                                    <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                                        <img src={item.patient_profile_picture || (getPublicImgUrl()+'/profile_8747415.png')} className="img-fluid rounded-top w-100" style={{ maxHeight: '250px', objectFit: 'contain' }} alt="" />
                                                    </div>
                                                    <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                                        <h5 className="mb-2">{item.patient_name}</h5>
                                                        <div className="appointment-item-div mb-3"><span><b>Date:</b></span> <span>{item.appointment_date}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Time:</b></span> <span>{item.appointment_time}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Reason:</b></span> <span>{item.visit_reason}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Payment Status:</b></span> <span>{item.payment_status ?? 'N/A'}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Booking Status:</b></span> <span>{item.booking_status ?? 'N/A'}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Fees:</b></span> <span><b>&#8377;{item.total_amount}</b></span></div>
                                                        <hr />
                                                        <button type="button" onClick={() => navigate(`/dashboard/doctor/appointment/${item.id}`)} className="btn btn-primary">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${appointmentActiveTab === 'previous' ? 'show active' : ''}`} id="pills-previous" role="tabpanel" aria-labelledby="pills-previous-tab">
                                    <div className="row g-3 justify-content-center">
                                        {appointments.previous.length === 0 && (<h4 className="mb-4 text-center">No Previous Appointments</h4>)}
                                        {appointments.previous.map((item, index, arr) => (
                                            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s" key={item.id}>
                                                <div className="team-item rounded">
                                                    <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                                        <img src={item.patient_profile_picture || (getPublicImgUrl()+'/profile_8747415.png')} className="img-fluid rounded-top w-100" style={{ maxHeight: '250px', objectFit: 'contain' }} alt="" />
                                                    </div>
                                                    <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                                        <h5 className="mb-2">{item.patient_name}</h5>
                                                        <div className="appointment-item-div mb-3"><span><b>Date:</b></span> <span>{item.appointment_date}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Time:</b></span> <span>{item.appointment_time}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Reason:</b></span> <span>{item.visit_reason}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Payment Status:</b></span> <span>{item.payment_status ?? 'N/A'}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Booking Status:</b></span> <span>{item.booking_status ?? 'N/A'}</span></div>
                                                        <div className="appointment-item-div mb-3"><span><b>Fees:</b></span> <span><b>&#8377;{item.total_amount}</b></span></div>
                                                        <hr />
                                                        <button type="button" onClick={() => navigate(`/dashboard/doctor/appointment/${item.id}`)} className="btn btn-primary">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-content d-flex flex-column">
                                        <p className="mb-2"><b>Visit Date Time:</b> 2023-08-01 10:00 AM</p>
                                        <p className="mb-2"><b>Patient Name:</b> Akash</p>
                                        <p className="mb-2"><b>Reason Of Visit:</b> 1234567890</p>
                                        <a href="#findDoctor" className="btn btn-primary rounded-pill text-white mt-2">More Details</a>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DoctorDashboard;